import { defineApiActionTypes } from 'store/common/action-helpers';

const prefix = 'features/claim-reports';

export const FETCH_CLAIM_REPORT = defineApiActionTypes(`${prefix}/FETCH_SINGLE`);
